import React from "react";
import "./Cars.css"; // Si vous avez un fichier CSS pour les styles de cette page
import SEO from "../SEO/SEO";

const Cars = () => {
  const cars = [
    {
      title: "Caravelle (8 PAX)",
      img: "/images/caravelle_2020.jpg",
      description: "The Volkswagen Caravelle offers space for up to 8 passengers, ideal for group travel with comfort and style.",
    },
    {
      title: "Renault Trafic (8 PAX)",
      img: "/images/renault_trafic_2020.jpg",
      description: "The Renault Trafic is a spacious and reliable choice for family trips or professional transport.",
    },
    {
      title: "Mercedes Class V (7 PAX)",
      img: "/images/mercedes_class_v_2020.jpg",
      description: "Luxurious and versatile, the Mercedes Class V accommodates up to 7 passengers with top-notch comfort.",
    },
    {
      title: "Mercedes Class S (3 PAX)",
      img: "/images/mercedes_class_s_2020.jpg",
      description: "The Mercedes Class S combines elegance and performance, perfect for executive travel with 3 passengers.",
    },
    {
      title: "Mercedes Class E (3 PAX)",
      img: "/images/mercedes_class_e_2020.jpg",
      description: "A perfect blend of luxury and technology, the Mercedes Class E is ideal for small groups of up to 3.",
    },
    {
      title: "Peugeot 508 (3 PAX)",
      img: "/images/peugeot_508_2020.jpg",
      description: "The Peugeot 508 offers a dynamic driving experience with a refined interior, perfect for business trips.",
    },
    {
      title: "Peugeot 5008 (6 PAX)",
      img: "/images/peugeot_5008_2020.jpg",
      description: "The Peugeot 5008 is a modern SUV with room for 6 passengers, ideal for family or leisure trips.",
    },
    {
      title: "Bus (50 PAX)",
      img: "/images/bus_50.jpg",
      description: "Comfortable and spacious, this bus is perfect for transporting up to 50 passengers for long or short journeys.",
    },
    {
      title: "Bus (61 PAX)",
      img: "/images/bus_61.jpg",
      description: "This bus accommodates 61 passengers, offering an excellent solution for large groups and events.",
    },
  ];

  return (
<div>
    <SEO
        title="Cars - RS Transports"
        description="Experience the elegance of our premium vehicles driven by professional chauffeurs."
        keywords="transport, airport transfers, paris, premium vehicles"
    />
    <div className="container py-5">
      <h1 className="text-center mb-4">Our Vehicles</h1>
      <div className="row">
        {cars.map((car, index) => (
          <div className="col-md-12 mb-4" key={index}>
            <div className="card bg-black">
              <img src={car.img} className="card-img-top" alt={car.title} />
              <div className="card-body">
                <h2 className="card-title">{car.title}</h2>
                <p className="card-text">{car.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
</div>
  );
};

export default Cars;
